import jsPDF from "jspdf";

const PrintKitchenCardMulti = (order) => {
    const createdDate = new Date(order.createdAt || Date.now());
    const mm = String(createdDate.getMonth() + 1).padStart(2, "0");
    const dd = String(createdDate.getDate()).padStart(2, "0");
    const yyyy = createdDate.getFullYear();
    const formattedDate = `${mm}-${dd}-${yyyy}`;

    order.items.forEach((item, index) => {
        let y = 10;

        const paperWidth = 58;
        const checkboxSize = 4;
        const marginLeft = 3; // make left margin smaller
        const spaceBetweenCheckboxAndText = 2;

        const textX = marginLeft + checkboxSize + spaceBetweenCheckboxAndText;
        const maxTextWidth = paperWidth - textX - 2;

        const wrapped = new jsPDF({ unit: "mm" }).splitTextToSize(
            `${item.amount}pc/s - ${item.name}`,
            maxTextWidth
        );

        const contentHeight =
            10 + 6 + 4 + 8 + (wrapped.length * 4.5) + 4 + 10;

        const doc = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: [paperWidth, contentHeight],
        });

        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text(`Order #: ${order.orderNumber}`, marginLeft, y);

        doc.setFontSize(20);
        if (order.salesType === "Dine-In") {
            doc.setTextColor("#2e7d32");
            doc.text("DI", paperWidth - 5, y + 2, { align: "right" });
          } else if (order.salesType === "Delivery") {
            doc.setTextColor("orange");
            doc.text("DEL", paperWidth - 5, y + 2, { align: "right" });
          } else {
            doc.setTextColor("#0277bd");
            doc.text("TO", paperWidth - 5, y + 2, { align: "right" });
          }
        doc.setTextColor(0);

        y += 6;
        doc.setFontSize(10);
        doc.text(`Tent #: ${order.tentNumber}`, marginLeft, y);
        y += 4;

        doc.setFontSize(8);
        doc.text("----------------------------------", paperWidth / 2, y, { align: "center" });
        y += 8;

        doc.rect(marginLeft, y - 3, checkboxSize, checkboxSize);

        doc.setFont("helvetica", "bold");
        doc.setFontSize(11);

        wrapped.forEach((line, i) => {
            doc.text(line, textX, y + i * 4.5);
        });

        y += wrapped.length * 4.5 + 4;

        const filename = `${formattedDate}-${order.orderNumber}-${index + 1}.pdf`;
        doc.save(filename);
    });
};

export default PrintKitchenCardMulti;
